export default {
  title: 'Rôles & Permissions',
  subtitle: 'Les rôles tenus dans cette organisation et dans ses espaces, et ce que chacun permet',
  createRole: 'Créer un rôle',
  createWorkspaceRole: "Créer un rôle d'espace",
  tabs: {
    organization: "Rôles d'organisation",
    workspace: "Rôles d'espace",
  },
  systemRole: 'Intégré',
  systemRoleDescription: 'Rôles déclarés par la plateforme : leur nom et leurs permissions ne sont pas modifiables',
  workspaceSystemRole: "Rôles d'espace intégrés",
  workspaceSystemRoleDescription: 'Admin, éditeur et lecteur, déclarés par la plateforme : ils ne sont pas modifiables',
  customRole: 'Personnalisé',
  customRoleDescription: 'Rôles définis par votre organisation, avec les permissions de son choix',
  workspaceCustomRole: "Rôles d'espace personnalisés",
  workspaceCustomRoleDescription: "Rôles d'espace définis par votre organisation, avec les permissions de son choix",
  sovereign: 'Contrôle total',
  sovereignHint:
    "Ce rôle détient toutes les permissions de l'organisation. Le dernier membre qui tient un tel rôle ne peut pas en être retiré.",
  memberCount: '{count} membre | {count} membres',
  permissionCount: '{count} permission | {count} permissions',
  noCustomRoles: 'Aucun rôle personnalisé créé',
  noCustomWorkspaceRoles: "Aucun rôle d'espace personnalisé créé",
  noWorkspaceSeat:
    "Les rôles d'espace se lisent à travers un espace dont vous faites partie, et vous ne faites partie d'aucun espace de cette organisation.",
  dormant: 'Inactive ici',
  dormantHint:
    "la fonctionnalité correspondante est désactivée dans cette organisation, personne ne l'exerce pour l'instant",
  builtInDescriptions: {
    org: {
      owner: "Possède l'organisation : tout ce qu'un administrateur peut faire, plus la transmettre et y mettre fin",
      admin: "Administre l'organisation : ses membres, ses rôles, ses paramètres et ses espaces",
      member: "Fait partie de l'organisation : crée des espaces, voit ceux qui lui sont ouverts, et invite",
      staff:
        'Opère la plateforme : la modération et son journal, les assets de toutes les organisations, les fichiers et sièges de la plateforme, et ses chiffres',
    },
    workspace: {
      admin: 'Administre cet espace : ses assets, ses paramètres et ses membres',
      editor:
        'Importe, modifie, partage et met à la corbeille des assets, en fait des collections, et gère leurs sous-titres',
      viewer: "Voit cet espace et tout ce qu'il contient, sans rien modifier",
    },
  },
  create: {
    title: 'Créer un rôle personnalisé',
    workspaceTitle: "Créer un rôle d'espace personnalisé",
    nameLabel: 'Nom du rôle',
    namePlaceholder: 'ex. Éditeur',
    keyLabel: 'Clé',
    keyHint: 'Lettres minuscules, chiffres et tirets bas. Elle ne pourra plus être changée.',
    keyInvalid: 'De 1 à 64 lettres minuscules, chiffres ou tirets bas.',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Décrivez ce que ce rôle peut faire...',
    success: 'Rôle créé avec succès',
  },
  detail: {
    backToRoles: 'Retour aux rôles',
    roleInfo: 'Informations du rôle',
    permissions: 'Permissions',
    permissionsDescription: 'Sélectionnez les permissions que ce rôle doit avoir',
    builtinNote:
      'Les rôles intégrés sont déclarés par la plateforme : leur nom et leurs permissions ne sont pas modifiables. Créez plutôt un rôle personnalisé.',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    dangerZone: 'Zone de danger',
    notFound: "Ce rôle n'existe pas dans cette organisation.",
    holders: 'Membres ayant ce rôle',
    holdersDescription: "Qui tient ce rôle dans l'organisation",
    noHolders: 'Personne ne tient ce rôle.',
    workspaceHoldersDescription: 'Qui tient ce rôle, et dans quels espaces',
    holdersNeedMembersManage: 'Seul un membre autorisé à gérer les membres voit qui tient ce rôle.',
  },
  delete: {
    title: 'Supprimer le rôle',
    actionTitle: 'Supprimer ce rôle',
    warning: 'Ce rôle sera définitivement supprimé. Cette action est irréversible.',
    hasMembers:
      "Ce rôle ne peut pas être supprimé car {count} membre(s) le tiennent. Attribuez-leur d'abord un autre rôle.",
    inUseHint:
      'Un rôle encore tenu par un membre, ou proposé par une invitation en attente, ne peut pas être supprimé.',
    confirm: 'Supprimer le rôle',
    success: 'Rôle supprimé avec succès',
  },
  groups: {
    auth_members: 'Membres',
    auth_org: 'Organisation',
    auth_roles: 'Rôles',
    auth_api_keys: 'Clés API',
    analytics_app: 'Analytics',
    analytics_sessions: 'Sessions de lecture',
    subtitles_scribe: 'Scribe',
    tenancy_billing: 'Facturation',
    tenancy_settings: 'Paramètres',
    tenancy_invitations: 'Invitations',
    tenancy_workspaces: 'Espaces',
    assets_asset: 'Contenus',
    assets_library: 'Bibliothèque',
    assets_collection: 'Collections',
    assets_subtitle: 'Sous-titres',
    assets_workspace: 'Espace',
    assets_members: "Membres de l'espace",
    tenancy_membership_requests: "Demandes d'adhésion",
    websites: 'Channels',
    onisep_partners: 'ONISEP',
  },
  permissionNames: {
    auth_members_manage: 'Gérer les membres',
    auth_members_invite: 'Inviter des personnes',
    auth_org_transfer: "Transférer l'organisation",
    auth_org_delete: "Supprimer l'organisation",
    auth_roles_manage: 'Gérer les rôles',
    auth_api_keys_manage: 'Gérer les clés API',
    analytics_app_access: 'Accéder à Analytics',
    analytics_sessions_read: "Lire les sessions de lecture par l'API",
    subtitles_scribe_access: 'Accéder à Scribe',
    tenancy_billing_manage: 'Gérer la facturation',
    tenancy_settings_manage: "Gérer les paramètres de l'organisation",
    tenancy_invitations_manage_all: 'Gérer toutes les invitations',
    tenancy_workspaces_create: 'Créer des espaces',
    tenancy_workspaces_view_all: 'Voir tous les espaces',
    tenancy_workspaces_view_public: 'Voir les espaces publics',
    tenancy_workspaces_access_all: 'Rejoindre tous les espaces',
    tenancy_workspaces_manage_all: 'Administrer tous les espaces',
    assets_asset_create: 'Créer et importer des contenus',
    assets_library_export: 'Exporter toute la bibliothèque',
    assets_library_read: "Lire la bibliothèque par l'API",
    assets_library_upload: "Ajouter des fichiers à la bibliothèque par l'API",
    assets_library_edit: "Modifier les contenus de la bibliothèque par l'API",
    assets_asset_delete: 'Supprimer définitivement des contenus',
    assets_asset_edit: 'Modifier les informations des contenus',
    assets_asset_export: 'Exporter les données des contenus',
    assets_asset_moderate: 'Modérer les contenus',
    assets_asset_share: 'Partager des contenus',
    assets_asset_trash: 'Mettre des contenus à la corbeille et les restaurer',
    assets_asset_view_analytics: "Voir les statistiques d'un contenu",
    assets_collection_create: 'Créer des collections',
    assets_collection_delete: 'Supprimer des collections',
    assets_collection_edit: 'Modifier des collections',
    assets_subtitle_edit: 'Créer, générer, importer et modifier des sous-titres',
    assets_subtitle_delete: 'Supprimer des sous-titres',
    assets_workspace_delete: "Supprimer l'espace",
    assets_workspace_invite_members: "Inviter des membres dans l'espace",
    assets_workspace_manage: "Gérer les paramètres de l'espace",
    assets_workspace_manage_members: "Gérer les membres de l'espace",
    assets_members_invite: "Inviter des membres dans l'espace",
    assets_members_manage: "Gérer les membres de l'espace",
    assets_third_party_video_import: "Importer des vidéos d'autres plateformes",
    tenancy_membership_requests_review: "Traiter les demandes d'adhésion",
    websites_website_create: 'Créer des sites',
    websites_website_manage: "Gérer les paramètres d'un site",
    websites_website_delete: 'Supprimer un site',
    websites_catalogue_edit: "Gérer le catalogue d'un site",
    websites_catalogue_read: "Lire les chaînes par l'API",
    websites_catalogue_publish: "Publier sur les chaînes par l'API",
    websites_pages_edit: "Modifier les pages d'un site",
    websites_members_view: "Voir les membres d'un site",
    websites_members_manage: "Gérer les membres d'un site",
    websites_grants_manage: "Gérer les accès aux contenus d'un site",
    websites_storefront_edit: "Gérer les offres et abonnements d'un site",
    websites_comments_moderate: "Modérer les commentaires d'un site",
    websites_submissions_manage: "Traiter les demandes et messages d'un site",
    websites_stats_view: "Voir les statistiques d'un site",
    onisep_partners_manage: 'Gérer les partenaires ONISEP',
  },
  // What each organization permission allows, shown on hover in the role editor. The server's
  // own English sentence is the fallback for a key missing here.
  permissionDescriptions: {
    auth_members_manage: "Changer le rôle d'un membre et retirer un membre de l'organisation",
    auth_members_invite: "Inviter des personnes à rejoindre l'organisation",
    auth_org_transfer: "Transmettre la propriété de l'organisation à un autre membre",
    auth_org_delete: "Supprimer l'organisation et tout ce qu'elle contient",
    auth_roles_manage: "Créer, modifier et supprimer les rôles propres à l'organisation",
    auth_api_keys_manage: "Créer, lister et révoquer les clés API de l'organisation",
    analytics_app_access: "Ouvrir l'application Analytics de l'organisation",
    analytics_sessions_read:
      "Lire par l'API publique les sessions de lecture de l'organisation : quel spectateur a regardé quel contenu, quand, combien de temps et quels passages",
    subtitles_scribe_access: "Ouvrir l'application de sous-titrage Scribe",
    tenancy_billing_manage: "Gérer la facturation et les crédits de l'organisation",
    tenancy_settings_manage: "Modifier les paramètres de l'organisation",
    tenancy_invitations_manage_all:
      "Voir et gérer toutes les invitations et tous les liens d'invitation en attente, pas seulement les siens",
    tenancy_workspaces_create: "Créer de nouveaux espaces dans l'organisation",
    tenancy_workspaces_view_all: "Voir tous les espaces de l'organisation, y compris les espaces privés",
    tenancy_workspaces_view_public: "Voir les espaces publics de l'organisation",
    tenancy_workspaces_manage_all: 'Administrer tous les espaces, privés compris, sans en être membre',
    tenancy_membership_requests_review:
      "Lire les demandes d'adhésion à l'organisation, les accepter ou les refuser, et être prévenu à chaque nouvelle demande",
    assets_library_export:
      "Exporter toute la bibliothèque de l'organisation, tous espaces compris, et consulter le journal des exports",
    assets_library_read:
      "Lire la bibliothèque de l'organisation par l'API publique : ses contenus, leurs descriptions et leurs espaces",
    assets_library_upload:
      "Ajouter des fichiers à la bibliothèque par l'API publique, en les envoyant ou en donnant un lien à récupérer",
    assets_library_edit:
      "Modifier par l'API publique ce que la bibliothèque contient déjà : les textes d'un contenu, ses tags, ses champs personnalisés et sa vignette",
    assets_third_party_video_import:
      'Importer dans la bibliothèque une vidéo hébergée ailleurs : YouTube, Vimeo, Dailymotion ou un lecteur accepté',
    websites_website_create: "Créer de nouveaux sites dans l'organisation",
    websites_website_manage: "Modifier le nom, l'apparence, les règles de connexion et les domaines d'un site",
    websites_website_delete: 'Supprimer un site, avec tout ce qui y est publié',
    websites_catalogue_edit: "Publier et dépublier les vidéos d'un site, et organiser ses catégories",
    websites_catalogue_read:
      "Lire les chaînes de l'organisation par l'API publique : les chaînes, leurs catégories et ce que chacune publie",
    websites_catalogue_publish:
      "Publier les vidéos de l'organisation sur ses chaînes par l'API publique : créer une publication, fixer son statut et son adresse, et la classer dans les catégories",
    websites_pages_edit: "Modifier les pages d'un site, leurs blocs et ses menus de navigation",
    websites_members_view: "Voir les membres d'un site et ce à quoi chacun a accès",
    websites_members_manage: "Ajouter, valider, suspendre, inviter et retirer les membres d'un site",
    websites_grants_manage: "Donner et retirer l'accès aux vidéos, catégories et groupes d'un site",
    websites_storefront_edit:
      "Fixer les prix et les formules d'abonnement d'un site, et ce que chaque formule comprend",
    websites_comments_moderate: 'Relire, répondre et supprimer les commentaires laissés sur un site',
    websites_submissions_manage:
      "Traiter ce que les visiteurs d'un site envoient : demandes d'accès, messages et dépôts",
    websites_stats_view: "Voir l'audience d'un site : vues, membres, sources et contenus les plus vus",
    onisep_partners_manage: "Créer, modifier et retirer les partenaires ONISEP de l'organisation",
  },
  // The short form of the same keys, for a sentence that says what a role allows: a verb per
  // permission, and the object its `<domain>.<resource>` group shares, so that two keys of one
  // group read « importer et modifier des contenus » rather than two full labels side by side.
  // A group with no object here has verbs that carry their own. A key missing here falls back to its
  // `permissionNames` label.
  permissionPhrases: {
    verbs: {
      assets_asset_create: 'importer',
      assets_asset_edit: 'modifier',
      assets_asset_share: 'partager',
      assets_asset_trash: 'mettre à la corbeille',
      assets_asset_delete: 'supprimer définitivement',
      assets_asset_export: 'exporter les données',
      assets_asset_moderate: 'modérer',
      assets_asset_view_analytics: 'voir les statistiques',
      assets_collection_create: 'créer',
      assets_collection_edit: 'modifier',
      assets_collection_delete: 'supprimer',
      assets_subtitle_edit: 'créer et modifier',
      assets_subtitle_delete: 'supprimer',
      assets_members_invite: 'inviter',
      assets_members_manage: 'gérer',
      assets_workspace_manage: "gérer les paramètres de l'espace",
      assets_workspace_delete: "supprimer l'espace",
    },
    objects: {
      assets_asset: 'des contenus',
      assets_collection: 'des collections',
      assets_subtitle: 'des sous-titres',
      assets_members: 'les membres',
    },
  },
  errors: {
    loadFailed: 'Erreur lors du chargement des rôles',
    saveFailed: "Erreur lors de l'enregistrement",
    createFailed: 'Erreur lors de la création du rôle',
    deleteFailed: 'Erreur lors de la suppression du rôle',
    keyTaken: 'Un rôle avec cette clé existe déjà dans cette organisation.',
    invalid:
      'Ce rôle ne peut pas être enregistré : vérifiez sa clé et son nom. Les rôles intégrés ne sont pas modifiables.',
    aboveOwnRole: 'Vous ne pouvez pas donner à un rôle une permission que votre propre rôle ne détient pas.',
    forbidden: "Vous n'avez pas le droit de modifier les rôles d'espace de cette organisation.",
    inUse:
      "Ce rôle est encore tenu par un membre ou proposé par une invitation en attente. Attribuez-leur d'abord un autre rôle.",
    seatsHoldIt: "Ce rôle est encore tenu dans un espace. Attribuez d'abord un autre rôle à ces membres.",
    lastAdministrator: "Cette modification ne laisserait personne capable d'administrer l'organisation.",
    notFound: "Ce rôle n'existe plus.",
    network: 'Le serveur est injoignable. Réessayez.',
  },
}
